import React from 'react';
import { Box, Typography, styled } from '@mui/material';

export interface CareProgramStatusPillProps {
  label: string;
}

const PillContainer = styled(Box)(({ theme }) => ({
  paddingInline: theme.spacing(1.5),
  paddingBlock: theme.spacing(1),
  borderRadius: theme.spacing(3.75),
  backgroundColor: theme.palette.brandBackgroundPrimary.main,
  flexShrink: 0,
}));

const PillLabel = styled(Typography)(() => ({
  fontWeight: 400,
  lineHeight: 2,
}));

export const CareProgramStatusPill: React.FC<CareProgramStatusPillProps> = ({ label }) => (
  <PillContainer>
    <PillLabel variant="caption" color="grey.800">
      {label}
    </PillLabel>
  </PillContainer>
);

export default CareProgramStatusPill;
